import React from 'react';
import { 
  HeroContainer, 
  HeroContent, 
  HeroHighlight, 
  HeroTitle, 
  HeroText 
} from './styles';

const Hero = () => {
  return (
    <HeroContainer>
      <HeroContent>
        <HeroHighlight>FLOQSS ES</HeroHighlight>
        <HeroTitle>La nueva forma segura de comprar, vender y acceder al mundo digital.</HeroTitle>
        <HeroText>
          Somos la primera empresa del mundo que miró de frente a millones de colombianos sin tarjeta o sin confianza en comprar online.
        </HeroText>
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;